import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { AgGridReact } from 'ag-grid-react';
import { AuditOutlined } from '@ant-design/icons';

import { Drawer, Button, Tooltip} from 'antd';

const height = window.innerHeight * .60;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

// const columnDefs = [
//     { headerName: 'Note Type', field: 'noteType', filter: 'agTextColumnFilter', width: 60 },
//     { headerName: 'Nunber of Notes', field: 'numberOfNotes', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
//     { headerName: 'Amount', field: 'amount', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
// ];

class DenominationDrawer extends Component {

    constructor(props) {
        super(props);
        
        this.store = props.store;
    }

    newRow = () => {

        return this.store.paymentType == "Cash" ? [
            { headerName: 'Note Type', field: 'noteType', filter: 'agTextColumnFilter', width: 60 },
            { headerName: 'Nunber of Notes', field: 'numberOfNotes', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
            { headerName: 'Amount', field: 'amount', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
        ] :  [
            { headerName: 'SID Code', field: 'SidCode', filter: 'agTextColumnFilter', width: 60 },
            { headerName: 'Customer name', field: 'CustomerName', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25 },
            { headerName: 'Amount', field: 'Amount', filter: 'agTextColumnFilter', width: 60 },
            { headerName: 'Charges', field: 'Charges', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 25 },
        ]

    }
    

    fetchData = () => {
        if(this.store.paymentType !== "Cash") {
            this.store.GetPaymentData();
        }
    }

    close = () => {
        this.store.isDrawerOpened = false;
    }

    approveDenomination = async () => {
        const id = [this.store.denominationId];
        await this.store.approve(id);
        this.close();
        this.store.fetchCashDenominations();
        this.props.gridRef.current.api.redrawRows();
    }

    approveButton = () => {
        if (this.props.appStore.isHead) {
            return (
                <Tooltip title="Csah Denomination Approval">
                    <Button onClick={() => this.approveDenomination()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} disabled={this.store.isLoading} icon={<AuditOutlined />}>Approve</Button>
                </Tooltip>
            )
        }
    }

    render() {
        const title = "Total:  " + this.store.totalAmount + "   Total Charges:  " + this.store.totalCharges;
        const denominationList = this.store.paymentType == "Cash" ? this.store.denominationNotes : this.store.paymentData;
        const columnDefs = this.newRow();
        return (
            <Drawer title={title} extra={[
                this.approveButton()
            ]} width={"50%"} closable={true} onClose={this.close} visible={this.store.isDrawerOpened} destroyOnClose>
                 <div className="ag-theme-alpine" style={{ height: height, width: '100%',backgroundColor: 'white' }}>
                        <AgGridReact
                            ref={this.gridRef}
                            defaultColDef={defaultColDef}
                            rowData={denominationList}
                            columnDefs={columnDefs}
                            enterMovesDown={true}
                            enterMovesDownAfterEdit={true}
                            rowHeight={25}
                            onGridReady={this.fetchData}
                        >
                        </AgGridReact>
                    </div>
            </Drawer>
        )
    }
}

export default observer(DenominationDrawer);
